/* istanbul ignore file */
import { Button } from 'framework/ui/mui-builder';
import azureIcon from 'infrastructure/security/authentication/OneClick/images/azure.png';
import { useAuthenticationUrl } from 'infrastructure/security/authentication/authenticationRouting';

const RedirectButton = ({ className }: { className?: string }) => {
  const { getAzureAuthUrl } = useAuthenticationUrl();

  const redirectToAzureLoginUrl = () => {
    window.location.assign(getAzureAuthUrl());
  };

  return (
    <Button
      key="oneclick-button"
      variant="outlined"
      onClick={redirectToAzureLoginUrl}
      className={className}
      sx={{ paddingRight: '20px', fontSize: '14px' }}
      endIcon={<img src={azureIcon} alt="" width={20} height={20} />}
    >
      Enter credentials instead
    </Button>
  );
};

export default RedirectButton;
